export { default as connectEntitlement } from './connect-entitlement.js';
export { default } from './entitlements-wrapper-container.js';

export const greaterThan = (i) => (v) => Number(v) && Number(v) > i;
export const greaterThanOrEqualTo = (i) => (v) => Number(v) && Number(v) >= i;
